import { isString } from '../../utils/lang';
export function containsStringMatcherContext(ruleAttr) {
    return function containsStringMatcher(runtimeAttr) {
        var contains = ruleAttr.some(function (e) { return isString(runtimeAttr) && runtimeAttr.indexOf(e) > -1; });
        return contains;
    };
}
